import React, { useState } from "react";
import { Button, Box, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import {
  setState,
  exportTemplate_DataSKUEdit,
  ImportExcelSKUEdit,
} from "./editScenarioNewSlice";

function BreakdownSKUUpload() {
  const [uploadedEditSKUFile, setuploadedEditSKUFile] = useState(null);
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.editScenarioNew);
  const { countryID, scenarioName, selectedCountry, selectedPGs, editScID } =
    setupState;
  const handleFileUploadSKU = (event) => {
    const fileObj = event.target.files[0];
    setuploadedEditSKUFile(fileObj);
  };

  const handleDeleteSKU = () => {
    setuploadedEditSKUFile(null);
  };
  const DownloadTemplateSKU = () => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      return;
    } else if (
      scenarioName === undefined ||
      scenarioName === null ||
      scenarioName === ""
    ) {
      showMessage("Please select a Scenario Name", "info");
      return;
    } else if (selectedPGs <= 0) {
      showMessage("Please select a SKU", "info");
      return;
    } else {
      let productsList = [];
      let productGroupsList = [];
      for (let i = 0; i < selectedPGs.length; i++) {
        if (selectedPGs[i].type === "P") {
          let obj = {};
          obj["id"] = selectedPGs[i].id;
          obj["name"] = selectedPGs[i].name;
          productsList.push(obj);
        } else if (selectedPGs[i].type === "PG") {
          let obj = {};
          obj["id"] = selectedPGs[i].id;
          obj["name"] = selectedPGs[i].name;
          productGroupsList.push(obj);
        } else if (selectedPGs[i].hasOwnProperty("productID")) {
          let obj = {};
          obj["id"] = selectedPGs[i].productID;
          obj["name"] = selectedPGs[i].name;
          productsList.push(obj);
        } else if (selectedPGs[i].hasOwnProperty("productGroupID")) {
          let obj = {};
          obj["id"] = selectedPGs[i].productGroupID;
          obj["name"] = selectedPGs[i].productGroupName;
          productGroupsList.push(obj);
        }
      }
      let obj = {
        scenarioId: editScID,
        scenarioName: scenarioName,
        countryId: countryID,
        countryName: selectedCountry,
        productGroup: productGroupsList,
        product: productsList,
        isSKUBreakdown: true,
      };
      dispatch(exportTemplate_DataSKUEdit(obj));
    }
  };
  const UploadFileSKU = () => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      return;
    } else if (
      scenarioName === undefined ||
      scenarioName === null ||
      scenarioName === ""
    ) {
      showMessage("Please select a Scenario Name", "info");
      return;
    } else if (selectedPGs <= 0) {
      showMessage("Please select a SKU", "info");
      return;
    } else {
      dispatch(setState("scenarioExternalDataSourceSKU", []));
      const formData = new FormData();
      formData.append("file", uploadedEditSKUFile, uploadedEditSKUFile.name);
      let recCnt = selectedPGs.length;
      let obj = {
        scenario: scenarioName,
        recCnt: recCnt,
        formData: formData,
      };
      dispatch(ImportExcelSKUEdit(obj));
      setuploadedEditSKUFile(null);
    }
  };
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  return (
    <Box>
      <Box>
        <Grid container spacing={3} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          <Grid item>
            <Box>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "grey.lighter",
                  color: "darkred.light",
                  textTransform: "none",
                  boxShadow: "none",
                  "&:hover": {
                    bgcolor: "darkred.light",
                    color: "white.main",
                  },
                }}
                component="span"
                onClick={DownloadTemplateSKU}
              >
                Download Template
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <Box>
              <input
                type="file"
                accept=".xls"
                onChange={handleFileUploadSKU}
                style={{ display: "none" }}
                id="fileInputsku"
                onclick="fileInputsku.value = null"
                value=""
              />
              <label htmlFor="fileInputsku">
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "grey.lighter",
                    color: "darkred.light",
                    textTransform: "none",
                    "&:hover": {
                      bgcolor: "darkred.light",
                      color: "white.main",
                    },
                  }}
                  component="span"
                >
                  Select File
                </Button>
              </label>
            </Box>
          </Grid>
          <Grid item>
            <Box>
              <Button
                variant="contained"
                disabled={
                  uploadedEditSKUFile == null ||
                  uploadedEditSKUFile == undefined
                }
                sx={{
                  bgcolor: "grey.lighter",
                  color: "darkred.light",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "darkred.light",
                    color: "white.main",
                  },
                }}
                component="span"
                onClick={UploadFileSKU}
              >
                Upload
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Grid>
        {/* <Box >
          {uploadedEditSKUFile && (
            <div className="file-display">
              <span>{uploadedEditSKUFile.name}</span>
              <Button variant="outlined" color="secondary" onClick={handleDeleteSKU}>
                <DeleteIcon />
              </Button>
            </div>
          )} */}
      {uploadedEditSKUFile && (
        <Box sx={{ mt: 2, borderBottom:0.25, borderColor: "#e0e0e0"}}>
            <div className="file-display" style={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <span>{uploadedEditSKUFile.name}</span>
              {/* <Button
                sx={{ ml: 5 }}
                variant="outlined"
                onClick={handleDeleteSKU}
              >
                <DeleteIcon /> &nbsp;Delete
              </Button> */}
               <DeleteIcon onClick={handleDeleteSKU} sx={{ cursor: "pointer"}}/> 
            </div>
        </Box>
      )}
      </Grid>
    </Box>
  );
}

export default BreakdownSKUUpload;
